import { SVGProps } from "react";

type Props = SVGProps<SVGSVGElement> & {
  color?: string;
  size?: number;
};
const SvgExploreIcon = ({ color, size = 40, ...props }: Props) => {
  return (
    <svg
      width={40}
      height={40}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      id="svg-wrapper"
      transform={`scale(${size / 40})`}
      {...props}
    >
      <path
        d="M11.425 27.875c-.175 0-.333.133-.341.308v.167a2.753 2.753 0 0 0 2.75 2.75 2.753 2.753 0 0 0 2.75-2.75v-.167c-.009-.175-.167-.308-.342-.308h-4.817ZM26.3 12.867H12.783v-4.35A.52.52 0 0 0 12.267 8h-3.75A.52.52 0 0 0 8 8.517v2.058a.52.52 0 0 0 .517.517H9.7v13.775a.532.532 0 0 0 .525.516h16.242a.5.5 0 0 0 .425-.225L31 19.967a.491.491 0 0 0 .083-.284v-6.3a.52.52 0 0 0-.516-.516h-4.275.008ZM19.784 27.875c-.175 0-.334.133-.342.308v.167a2.753 2.753 0 0 0 2.75 2.75 2.753 2.753 0 0 0 2.75-2.75v-.167c-.008-.175-.167-.308-.342-.308h-4.816Z"
        fill={color || "#595959"}
      />
    </svg>
  );
};
export default SvgExploreIcon;
